// deprecated (kept for password/new and password/edit)
import React from "react";
import PropTypes from "prop-types";
import Box from "./index";
import {
  BoxForm as StyledBoxForm,
  BoxHeadline,
  DescHeadline,
  WButton
} from "components/BoxForm";
import tw from "twin.macro";
import styled from "styled-components";

const Show = (props) => (props.enabled ? props.children : "");

const SubmitButton = styled(WButton)`
  ${tw`mt-4`}
`;

export const BoxForm = (props) => (
  <Box>
    <StyledBoxForm
      action={props.action || "#"}
      disabled={props.disabled}
      onSubmit={props.onSubmit}
    >
      <Show enabled={props.title}>
        <BoxHeadline className={props.titleClassName}>
          {props.title}
        </BoxHeadline>
      </Show>

      <Show enabled={props.subtitle}>
        <DescHeadline className={props.subtitleClassName}>
          {props.subtitle}
        </DescHeadline>
      </Show>

      {props.children}

      <SubmitButton
        value={props.submitTitle || "Reset"}
        disabled={props.disabled}
        type="submit"
      />
    </StyledBoxForm>
  </Box>
);

BoxForm.propTypes = {
  action: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  formProps: PropTypes.object,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  subtitle: PropTypes.string,
  subtitleClassName: PropTypes.string,
  onSubmit: PropTypes.func,
  submitTitle: PropTypes.string
};

export default BoxForm;
